// src/pages/InventoryApproval.tsx

import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import {
  Button,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { formatDate } from "../../utils/utils";
import { brandColors } from "../../App";

interface InventoryItem {
  name: string;
  description: string;
  product_id: string;
  packed: number;
  units: number;
  supplier: string;
  sending_store?: { name: string; id: string };
}

const InventoryApproval: React.FC = () => {
  const token = useSelector((state: RootState) => state.auth.token);
  const [items, setItems] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [status, setStatus] = useState<string>("PENDING");

  const getTransferData = async () => {
    try {
      const response = await fetch(`/api/transfers/transferList`, {
        method: "POST", // ✅ Make sure your backend supports POST with body
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ status }),
      });
      const data = await response.json();
      if (!response.ok) {
        console.error("Failed to fetch inventory:", data);
        return;
      }
      setItems(data);
    } catch (error) {
      console.error("Error fetching inventory:", error);
    } finally {
      setLoading(false);
    }
  };
  const handleApprove = async (item: any) => {
    // Call API to approve transfer
    try {
      const response = await fetch(`/api/transfers/approveTransfer`, {
        method: "POST", // ✅ Make sure your backend supports POST with body
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ item }),
      });
      const data = await response.json();
      if (!response.ok) {
        console.error("Failed to approve inventory:", data);
        return;
      }

      if (response.status === 200) {
        setItems(items.filter((i) => i.product_id !== item.product_id));
        alert("Inventory approved successfully");
      }
    } catch (error) {
      console.error("Error approving inventory:", error);
      alert("Error approving inventory");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // console.log("Fetching transfers with status:", status);
    getTransferData();
  }, [status]);

  //   if (loading) return <p>Loading...</p>;

  return (
    <div style={{ padding: "2rem" }}>
      <Typography variant="h5" gutterBottom>
        Inventory Transfer Approvals
      </Typography>

      {loading ? (
        <CircularProgress />
      ) : (
        <TableContainer component={Paper}>
          <Table stickyHeader size="small">
            <TableHead sx={{ backgroundColor: brandColors.header }}>
              <TableRow>
                <TableCell sx={{ color: "white",backgroundColor: brandColors.header, fontWeight: 600, fontSize:'16px' }}>Product</TableCell>
                {/* <TableCell sx={{color: "white",backgroundColor: brandColors.header, fontWeight: 600, fontSize:'16px'}}>Description</TableCell> */}
                <TableCell sx={{ color: "white",backgroundColor: brandColors.header, fontWeight: 600, fontSize:'16px' }}>Supplier</TableCell>
                <TableCell sx={{ color: "white",backgroundColor: brandColors.header, fontWeight: 600, fontSize:'16px' }}>Date</TableCell>
                <TableCell sx={{ color: "white",backgroundColor: brandColors.header, fontWeight: 600, fontSize:'16px' }}>Units</TableCell>
                <TableCell sx={{ color: "white",backgroundColor: brandColors.header, fontWeight: 600, fontSize:'16px' }}>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {items.map((item) => (
                <TableRow key={item.product_id}>
                  <TableCell>{item.product}</TableCell>
                  {/* <TableCell>{item.description}</TableCell> */}
                  <TableCell>{item.store}</TableCell>
                  <TableCell>{formatDate(item.created_at)}</TableCell>
                  <TableCell>{item.qty_packed}</TableCell>
                  <TableCell>
                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      onClick={() => handleApprove(item)}
                    >
                      Approve
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
              {items.length === 0 && (
                <TableRow>
                  <TableCell colSpan={6} align="center">
                    No items to approve
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </div>
  );
};

export default InventoryApproval;
